import { render } from "./FeaturesView.vue?vue&type=template&id=1d50b222&scoped=true"
import script from "./FeaturesView.vue?vue&type=script&lang=js"
export * from "./FeaturesView.vue?vue&type=script&lang=js"

import "./FeaturesView.vue?vue&type=style&index=0&id=1d50b222&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d50b222"]])

export default __exports__